<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <section class="bread_crumb">
            <div class="container">
                <ul>
                    <li>
                        <router-link class="nav-link" v-bind:to="'/'">{{ $t("Header.Home") }}</router-link>
                    </li>

                    <li  v-if="page_title!=null" v-html="page_title"></li>
                </ul>
            </div>
        </section>
        <section class="inner_wrap">
            <div class="container">            
                <div class="row">
                    <div class="col-md-12">
                        <div class="about_text" v-if="page_title!=null">
                            <h2 v-html="page_title"></h2>
                            <div v-html="page_content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>


import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
import EventBus from '../EventBus'

export default{
    data(){
        this.get_page_content();
        return {
            page_title:null,
            page_content:null                                                                        
        }
    },
    components:{
        HeaderMenu:HeaderMenu,
    },
    methods:{
        async get_page_content() {
            var _self = this; 
            var current_slug = 'terms-and-conditions';
            await axios.post(_self.$hostname+'/api/static-pages',
            {
              slug:current_slug,lang:_self.$i18n_global.locale
            })
            .then((res) => {
                var response = res.data.data;
                _self.page_title = _self.$i18n_global.locale=="en" ? response.heading_eng : response.heading_ar;
                _self.page_content = _self.$i18n_global.locale=="en" ? response.description_eng : response.description_ar; 
            })
            .catch((error) => {
                
                return false;  
            }) 
            return false; 
        }
    },
    /*watch: {
        '$route.params.slug'(newSlug, oldSlug) {
            this.get_page_content();
        }
    },*/
}
</script>


// WEBPACK FOOTER //
// src/components/Pages/TermsAndConditions.vue